
import React from 'react'
import { InputContainer } from '../../../../../common/components/form/form.module';
import GoogleMapSearch from '../../../../../common/components/google-map-search';

export default function ParcelBasicInfoComponent({ handleCustomerSearch, customerListData, dropLocations, pickupLocations, leadValues, setPickupLocation, filterCustomer, handleChange, setDropLocation }: any) {

    return (

        <div className="w-full max-w-5xl mx-auto p-6 bg-white shadow-lg rounded-lg border border-gray-200 space-y-6">
            <div className="flex flex-col ">
                <InputContainer
                    required
                    label="Existing User *"
                    name="IsExistingUser"
                    onValueChange={(event) => handleChange(event, 'IsExistingUser')}
                    type="checkbox"
                    value={leadValues?.IsExistingUser}
                />
                {leadValues?.IsExistingUser && (
                    <InputContainer
                        label="Customer Name"
                        labelField="AccountName"
                        list={customerListData?.result?.items}
                        onTypeahead={(event) => handleCustomerSearch({ event })}
                        onValueChange={(event) => handleChange(event, 'CustomerId')}
                        type="typeahead"
                        value={leadValues?.CustomerId}
                        valueField="Id"
                    />
                )}
                {!leadValues?.IsExistingUser && (
                    <div className="space-y-3">
                        <div>
                            <label className="block text-xs font-semibold text-gray-700">Email *</label>
                            <input
                                required
                                type="email"
                                name="Email"
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                                onChange={(event) => handleChange(event.target.value, 'Email')}
                                value={leadValues?.Email}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-semibold text-gray-700">Name *</label>
                            <input
                                required
                                type="text"
                                name="Name"
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                                onChange={(event) => handleChange(event.target.value, 'Name')}
                                value={leadValues?.Name}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-semibold text-gray-700">Phone Number *</label>
                            <input
                                required
                                type="number"
                                name="PhoneNumber"
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                                onChange={(event) => handleChange(event.target.value, 'PhoneNumber')}
                                value={leadValues?.PhoneNumber}
                            />
                        </div>
                    </div>
                )}
            </div>

            {leadValues?.CustomerId && leadValues?.IsExistingUser && (
                <div className="space-y-3">
                    <div>
                        <label className="block text-xs font-semibold text-gray-700">Email</label>
                        <div className="border border-gray-300 text-xs rounded-lg px-3 py-2 bg-gray-50">{filterCustomer?.Email}</div>
                    </div>
                    <div>
                        <label className="block text-xs font-semibold text-gray-700">Phone number</label>
                        <div className="border border-gray-300 text-xs rounded-lg px-3 py-2 bg-gray-50">{filterCustomer?.PhoneNumber}</div>
                    </div>
                </div>
            )}
            {/* Package Dimensions */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-xs font-semibold  text-gray-700">Weight</label>
                    <input
                        type="text"
                        name="weight"
                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                        onChange={(event) => handleChange(event.target.value, 'weight')}
                        value={leadValues?.weight}
                    />
                    <label className="block text-xs font-light text-right text-gray-500">
                        in kg
                    </label>
                </div>
                <div>
                    <label className="block text-xs font-semibold  text-gray-700">Length</label>
                    <input
                        type="text"
                        name="length"
                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                        onChange={(event) => handleChange(event.target.value, 'length')}
                        value={leadValues?.length}
                    />
                    <label className="block text-xs font-light text-right text-gray-500">
                        in mm
                    </label>
                </div>
                <div>
                    <label className="block text-xs font-semibold  text-gray-700">Breadth</label>
                    <input
                        type="text"
                        name="breadth"
                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                        onChange={(event) => handleChange(event.target.value, 'breadth')}
                        value={leadValues?.breadth}
                    />
                    <label className="block text-xs font-light text-right text-gray-500">
                        in mm
                    </label>
                </div>
                <div>
                    <label className="block text-xs font-semibold  text-gray-700">Height</label>
                    <input
                        type="text"
                        name="height"
                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                        onChange={(event) => handleChange(event.target.value, 'height')}
                        value={leadValues?.height}
                    />
                    <label className="block text-xs font-light text-right text-gray-500">
                        in mm
                    </label>
                </div>
            </div>

            {/* Address Fields */}
            <div className="space-y-3">
                <div>
                    <label className="block text-xs font-semibold text-gray-700">From *</label>
                    <GoogleMapSearch setLocation={setPickupLocation} location={pickupLocations} placeholder="From Address" />
                </div>
                <div>
                    <label className="block text-xs font-semibold text-gray-700">To *</label>
                    <GoogleMapSearch setLocation={setDropLocation} location={dropLocations} placeholder="To Address" />
                </div>
            </div>

            <div className="space-y-2">
                <div>
                    <label className="text-xs font-semibold text-gray-700">Schedule Date *</label>
                    <input
                        type="date"
                        name={"frodatem"}
                        min={new Date().toISOString().split("T")[0]}
                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50"
                        onClick={(event) => {
                            const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                            input.showPicker(); // Now you can call showPicker() safely
                        }}
                        onChange={(event) => {
                            handleChange(
                                event.target.value,
                                'date'
                            );
                        }}
                        value={leadValues?.date}
                    />
                </div>
            </div>

            <div className="space-y-3">
                <div>
                    <label className="block text-xs font-semibold text-gray-700">Additional Information</label>
                    <textarea
                        name="Description"
                        className="w-full h-14 border border-gray-300 text-xs rounded-lg px-4 py-2 bg-gray-50"
                        onChange={(event) => handleChange(event.target.value, 'Description')}
                        value={leadValues?.Description}
                    />
                </div>
            </div>
        </div>



    )
}